var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"传播足迹","memo":"查看机构心理师传播足迹"}}),_c('a-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }